let myApiUrl = process.env.GATSBY_LK_URL;
if (process.env.GATSBY_MODE === 'development') {
  myApiUrl = 'http://0.0.0.0:7777';
}

export const apiMyLead = `${myApiUrl}/api/crm/oldFormatLead`;
export const apiRegistrationForEvent = `${myApiUrl}/event`;
export const apiPayment = `${myApiUrl}/api/payments/create`;
export const apiAdvcake = `${myApiUrl}/api/advcake/postback`;
export const baseUrl = process.env.GATSBY_SELF_URL;

// События, которые сортируются по времени и фильтруются по полю "Показывать для пользователей"
export const allEvents = `${process.env.GATSBY_API_URL}/events?_sort=date:ASC&show=true`;
export const allEventsTest = `${process.env.GATSBY_API_URL}/events?_sort=date:ASC`;
export const oneEvent = `${process.env.GATSBY_API_URL}/events/`;
export const allPrices = `${process.env.GATSBY_API_URL}/prices`;
export const allGroups = `${process.env.GATSBY_API_URL}/groups`;
export const allFAQs = `${process.env.GATSBY_API_URL}/faqs`;
export const allCourses = `${process.env.GATSBY_API_URL}/courses`;
